import BasePointTagManager from "../../../../src/managers/BasePointTagManager";

export default class PointTagManager extends BasePointTagManager {
  constructor(cCoord) {
    super(cCoord, ["A", "B", "C", "D"])
  }
}